import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AnnouncementsLandingPageRoute extends Route {
  @service state;
  @service store;
  @service router;

  model() {
    const { announcements } = this.modelFor('protect.announcements');

    return { announcements };
  }

  afterModel({ announcements }) {
    if (announcements.length) {
      this.router.transitionTo('protect.announcements.list');
    }
  }
}
